import {
  CREATE_BUSINESS_LINE,
  CREATE_BUSINESS_LINE_SUCCESS,
  CREATE_BUSINESS_LINE_ERROR,
  DELETE_BUSINESS_LINE,
  DELETE_BUSINESS_LINE_SUCCESS,
  DELETE_BUSINESS_LINE_ERROR,
  HIDE_DELETE_BUSINESS_LINE_ERROR,
} from '../constants/action-types/businessLines';
import { initialStateBusinessLines } from '../store/models/businessLines';

export default function businessLinesReducer(state = initialStateBusinessLines, action) {
  switch (action.type) {
    case CREATE_BUSINESS_LINE:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_BUSINESS_LINE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        businessLine: action.payload.businessLine,
      };
    case CREATE_BUSINESS_LINE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case DELETE_BUSINESS_LINE:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_BUSINESS_LINE_SUCCESS:
      return {
        ...state,
        businessLine: initialStateBusinessLines.businessLine,
      };
    case DELETE_BUSINESS_LINE_ERROR:
      return {
        ...state,
        deleteBusinessLineError: action.payload.error.response.data.msg,
      };
    case HIDE_DELETE_BUSINESS_LINE_ERROR:
      return {
        ...state,
        isLoading: false,
        deleteBusinessLineError: undefined,
      };
    default:
      return state;
  }
}
